import angular from 'angular';
import SignalRService from '@/shared/services/SignalRService';
import { Transaction } from '../model/transaction';

angular
  .module('cxInvoicing')
  .controller('TransactionOverviewCtrl', [
    '$scope',
    '$state',
    '$q',
    'transactionHttpSvc',
    'flySvc',
    'invoicingSvc',
    'invoiceDialogsSvc',
    'appMessages',
    'dialogsSvc',
    '$http',
    'appUrls',
    'localStorageService',
    'enumCacheSvc',
    transactionOverviewCtrl,
  ]);
const emptyFilters = {
  closed: false,
  ownCompanies: [],
};
function transactionOverviewCtrl(
  $scope,
  $state,
  $q,
  transactionHttpSvc,
  flySvc,
  invoicingSvc,
  invoiceDialogsSvc,
  appMessages,
  dialogsSvc,
  $http,
  appUrls,
  localStorageService,
  enumCacheSvc,
) {
  var vm = this;
  var filterStorageKey = 'cx-transactions-filters';
  vm.transactionSources = [];

  vm.selectAll = false;
  vm.autoLinkAttempted = false;
  vm.dropObject = null;
  vm.isClosed = false;
  vm.filters = {
    ...emptyFilters,
    ...(localStorageService.get(filterStorageKey) || {}),
  };

  vm.currentFilters = { ...vm.filters };
  vm.documents = [];
  vm.document = null;
  vm.tableParams = null;

  enumCacheSvc.get('transactionSource').then(function(data) {
    vm.transactionSources = (data || []).map(x => x.key);
  });

  var showError = function(error) {
    flySvc.error(error);
  };

  vm.retrieve = function(params) {
    vm.selectAll = false;
    vm.currentFilters = { ...vm.filters };
    vm.tableParams = params;
    return transactionHttpSvc.getTransactions({ ...params, ...vm.filters });
  };

  vm.selectedCount = function() {
    if (!vm.transactions || !vm.transactions.rows) return 0;
    const count = vm.transactions.rows.reduce(
      (cnt, x) => cnt + (!!x.selected !== vm.selectAll ? 1 : 0),
      0,
    );
    return vm.selectAll ? 1 : count;
  };

  vm.documentChanged = function() {
    const id = vm.document ? vm.document.id : null;
    vm.updateFilter({ documentId: id });
  };

  var refresh = function() {
    if (vm.transactions && vm.transactions.reload) {
      vm.transactions.reload();
    }
    retrieveDocuments();
  };

  vm.selectAllChanged = function() {
    if (!vm.transactions || !vm.transactions.rows) return;
    angular.forEach(vm.transactions.rows, function(el) {
      el.selected = vm.selectAll;
    });
  };
  vm.getBatchSelectionParams = function() {
    return {
      selectAll: vm.selectAll,
      ids:
        vm.transactions && vm.transactions.rows
          ? vm.transactions.rows.filter(x => !!x.selected !== vm.selectAll).map(x => x.id)
          : [],
    };
  };
  vm.batchDeleteTransactions = function() {
    var batchParams = vm.getBatchSelectionParams();

    const bodyParams = {
      ...vm.currentFilters,
      ...batchParams,
    };

    const queryParams = vm.tableParams;
    $http
      .post(appUrls.api + '/api/transaction/DeleteTransactions', bodyParams, {
        params: queryParams,
      })
      .then(result => {
        flySvc.success('msgXTransactionsDeleted', {
          p0: result.data,
        });
        if (batchParams.selectAll && vm.currentFilters.documentId) {
          delete vm.currentFilters.documentId;
        }
        refresh();
      }, showError);
  };
  vm.togglePayments = function(trans) {
    if (trans.payments.length) trans.showPayments = !trans.showPayments;
  };
  vm.deletePayment = function(payment) {
    if (!payment || !payment.id) return;
    transactionHttpSvc.removePayment(payment.id).then(function() {
      vm.reloadUnpaidInvoices();
      refresh();
    }, showError);
  };

  var retrieveDocuments = () => {
    const { closed } = vm.filters;
    var deferred = $q.defer();
    $http
      .get(appUrls.api + '/api/transaction/GetCodaFiles?closed=' + closed, {
        timeout: deferred.promise,
        cancel: deferred,
      })
      .then(result => {
        if (result && result.data) {
          vm.documents = result.data.map(x => ({
            id: x.documentId,
            label: x.documentName,
          }));
          const filters = localStorageService.get(filterStorageKey) || {};
          const { documentId } = vm.filters;

          if (documentId) {
            vm.document = vm.documents.find(x => x.id === documentId);
            if (!vm.document) {
              delete vm.filters.documentId;
              if (vm.transactions && vm.transactions.reload) {
                vm.transactions.reload();
              }
            }
          } else {
            vm.document = undefined;
          }
        }
      });
  };
  retrieveDocuments();
  vm.addTransaction = function() {
    const companyId =
      vm.filters.ownCompanies && vm.filters.ownCompanies.length === 1
        ? vm.filters.ownCompanies[0]
        : null;

    invoiceDialogsSvc.newTransaction(companyId).then(function(result) {
      refresh();
    });
  };

  vm.linkTransaction = function(transaction) {
    invoiceDialogsSvc.newTransactionPayment(transaction, null).then(function(result) {
      if (result) {
        vm.reloadUnpaidInvoices();
        refresh();
      }
    });
  };

  vm.editTransaction = function(trans) {
    invoiceDialogsSvc.editTransaction(angular.copy(trans)).then(function(result) {
      if (result) {
        if (result.status !== 0) {
          // transaction was closed, probably because the amount was edited
          if (!vm.transactions || !vm.transactions.rows) return;
          var idx = vm.transactions.rows.indexOf(trans);
          if (idx >= 0) vm.transactions.rows.splice(idx, 1);
        } else {
          angular.copy(new Transaction(result), trans);
        }
      }
    });
  };

  vm.removeTransaction = function(trans) {
    const information =
      trans.payments && trans.payments.length && trans.payments.length > 0
        ? 'msgArchiveTransactionExplanation'
        : 'msgDeleteTransaction';
    return dialogsSvc.showYesNo('comfirmDeleteTitle', information).then(
      function(result) {
        transactionHttpSvc.removeTransaction(trans.id).then(function() {
          if (!vm.transactions || !vm.transactions.rows) return;
          var idx = vm.transactions.rows.indexOf(trans);
          if (idx >= 0) vm.transactions.rows.splice(idx, 1);
        }, showError);
        return true;
      },
      function() {
        return false;
      },
    );
  };

  vm.unarchiveTransaction = function(trans) {
    transactionHttpSvc.unarchiveTransaction(trans).then(function() {
      if (!vm.transactions || !vm.transactions.rows) return;
      var idx = vm.transactions.rows.indexOf(trans);
      if (idx >= 0) vm.transactions.rows.splice(idx, 1);
      flySvc.info('msgTransactionMovedToOpenTransactions');
    }, showError);
  };

  vm.dropInvoice = function(e, ui, transaction, invoice) {
    if (vm.filters.closed || !invoice || !transaction) return;
    invoiceDialogsSvc.newTransactionPayment(transaction, invoice).then(function() {
      vm.reloadUnpaidInvoices();
    });
  };

  vm.canAutoLink = function() {
    if (vm.filters.closed || !vm.transactions || !vm.transactions.rows) return false;
    for (var i = 0; i < vm.transactions.rows.length; i++)
      if (vm.transactions.rows[i].openAmount() !== 0 && vm.transactions.rows[i].linkStatus == null)
        return true;
    return false;
  };

  vm.linkAll = function() {
    if (vm.filters.closed || !vm.transactions || !vm.transactions.rows) return;
    vm.linking = true;
    return transactionHttpSvc
      .matchAllTransactions({ ...vm.transactions.currentParams(), ...vm.filters })
      .then(function(result) {
        vm.autoLinkAttempted = true;
        vm.linking = false;
        if (result && result.length) {
          var rows = result.map(res => {
            var trans = new Transaction(res.transaction);
            trans.matches = res.matches || [];
            trans.candidates = res.candidates || [];
            if (res.matches && res.matches.length) {
              trans.linkStatus = 2;
              trans.linkMsg = appMessages('linkTransSuccess', {
                invNr: res.matches[0].number,
              });
            } else if (res.candidates && res.candidates.length) {
              trans.linkStatus = 1;
              trans.linkMsg = appMessages('linkTransMultiple', {
                nr: res.candidates.length,
              });
            } else {
              trans.linkStatus = 0;
              trans.linkMsg = appMessages('linkTransFailed');
            }
            return trans;
          });

          vm.transactions.setRows(rows, true);
          if (rows.some(x => x.linkStatus === 2)) vm.reloadUnpaidInvoices();
        }
      });
  };

  vm.toggleClosed = function(param) {
    if (param === 1) {
      vm.updateFilter({ closed: true });
    } else {
      vm.updateFilter({ closed: false });
    }
  };

  vm.companyFilterChanged = function() {
    vm.updateFilter();
    vm.reloadUnpaidInvoices();
  };

  vm.updateFilter = function(value, noReload) {
    if (value) {
      vm.filters = { ...vm.filters, ...value };
      localStorageService.set(filterStorageKey, vm.filters);
    }
    if (!noReload && !angular.equals(vm.currentFilters, vm.filters)) {
      refresh();
    }
  };

  vm.uploadCODA = function() {
    const companyId =
      vm.filters.ownCompanies && vm.filters.ownCompanies.length === 1
        ? vm.filters.ownCompanies[0]
        : null;
    invoiceDialogsSvc.uploadCODA(companyId);
  };

  vm.reloadUnpaidInvoices = function() {
    const filters =
      vm.filters.ownCompanies && vm.filters.ownCompanies.length
        ? { ownCompanies: vm.filters.ownCompanies }
        : {};

    return invoicingSvc.reloadUnpaidInvoices(10, filters);
  };
}
